import { DimeSpinner } from '@nudool/design-system';
import { createRouter } from '@tanstack/react-router';

import { RouteNotFound } from './components/RouteNotFound.js';
import type { ReorderPrefill } from './modules/inventory/reorder-sheet/reorder-prefill.js';
import type { ReorderStarted } from './modules/inventory/reorder-sheet/reorder-started.js';
import { routeTree } from './routeTree.gen.js';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultNotFoundComponent: RouteNotFound,
  defaultPendingComponent: () => (
    <div className="flex flex-1 items-center justify-center py-24">
      <DimeSpinner />
    </div>
  ),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    reorderPrefill?: ReorderPrefill;
    reorderStarted?: ReorderStarted;
    returnTo?: string;
  }
}
